import React, { createContext, useEffect, useState } from 'react';
import { GetOrderPerformance, FilterCustomReport, getCampaignPerformance } from '../services/CampaignsDataService';

const PerformanceContext = createContext();

// ASSP-7733 Add financialStats for FigureCards
//
const PerformanceProvider = ({ children }) => {
    const [spotTypes, setSpotTypes] = useState([]);
    const [airtimeBursts, setAirtimeBursts] = useState([]);
    const [properties, setProperties] = useState([]);
    const [versions, setVersions] = useState([]);
    const [demographics, setDemographics] = useState([]);
    const [surveys, setSurveys] = useState([]);
    const [performanceData, setPerformanceData] = useState([]);
    const [dayPartTable, setDayPartTable] = useState([]);
    const [deliveryTable, setDeliveryTable] = useState({});
    const [dayParts, setDayparts] = useState([]);
    const [stations, setStations] = useState([]);
    const [scriptFactors, setScriptFactors] = useState([]);
    const [campaign, setCampaign] = useState();
    const initFinancialStats = { reach: 'total', oth: 'overall' };
    const [financialStats, setFinancialStats] = useState({});
    const [filters, setFilters] = useState({
        loaded: false,
        demographicId: 0,
        surveyId: 0,
        versionId: 0,
        spotTypeIds: [],
        dayPartIds: [],
        stationIds: [],
        propertySelectionIds: [],
        campaignBurstIds: [],
        propertyIds: [],
        scriptFactorIds: [],
        dateRange: []
    });
    const [loadingData, setLoadingData] = useState(false);
    const toTime = (v) => {
        var h = Math.floor(v / 3600);
        var m = Math.floor((v - h * 3600) / 60);
        return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
    };
    const loadDataPartial = () => {
        if (!campaign?.id) return;
        getCampaignPerformance(campaign?.id, filters)
            .then((data) => {
                setLoadingData(false);

                const dps = data.dayParts.map((a, b) => {
                    return {
                        id: a.orderStartTime * 1000000 + a.orderEndTime,
                        name: toTime(a.orderStartTime) + '-' + toTime(a.orderEndTime)
                    };
                });

                if (!filters.dayPartIds?.length) {
                    if (dps.length > 1) {
                        setDayparts([{ id: 0, name: window.translate('All') }, ...dps]);
                    } else {
                        setDayparts(dps);
                    }
                }

                if (!filters.stationIds?.length) {
                    if (data.stations.length > 1) {
                        setStations([{ id: 0, name: window.translate('All') }, ...data.stations]);
                    } else {
                        setStations(data.stations);
                    }
                }
                if (!filters.scriptFactorIds?.length) {
                    if (data.scriptFactors.length > 1) {
                        setScriptFactors([{ id: 0, name: window.translate('All') }, ...data.scriptFactors]);
                    } else {
                        setScriptFactors(data.scriptFactors);
                    }
                }
                if (!filters.spotTypeIds?.length) {
                    if (data.spotTypes.length > 1) {
                        setSpotTypes([{ id: 0, name: window.translate('All') }, ...data.spotTypes]);
                    } else {
                        setSpotTypes(data.spotTypes);
                    }
                }

                setPerformanceData(data.items);
                setDayPartTable(data.dayPartTable);
                setDeliveryTable(data.delivery);
                setLoadingData(false);
            })
            .catch();
    };
    const loadData = () => {
        if (!campaign?.id) return;
        getCampaignPerformance(campaign?.id, filters)
            .then((data) => {
                if (!data.stations) {
                    setLoadingData(false);
                    return;
                }
                setLoadingData(false);
                setSurveys(data.surveys);
                setDemographics(data.demographics);
                const dps = data.dayParts.map((a, b) => {
                    return {
                        id: a.orderStartTime * 1000000 + a.orderEndTime,
                        name: toTime(a.orderStartTime) + '-' + toTime(a.orderEndTime)
                    };
                });
                if (dps.length > 1) {
                    setDayparts([{ id: 0, name: window.translate('All') }, ...dps]);
                } else {
                    setDayparts(dps);
                }
                if (data.stations.length > 1) {
                    setStations([{ id: 0, name: window.translate('All') }, ...data.stations]);
                } else {
                    setStations(data.stations);
                }
                setVersions(data.versions);
                if (data.scriptFactors.length > 1) {
                    setScriptFactors([{ id: 0, name: window.translate('All') }, ...data.scriptFactors]);
                } else {
                    setScriptFactors(data.scriptFactors);
                }
                if (data.spotTypes.length > 1) {
                    setSpotTypes([{ id: 0, name: window.translate('All') }, ...data.spotTypes]);
                } else {
                    setSpotTypes(data.spotTypes);
                }
                setAirtimeBursts(data.airtimeBursts);
                setProperties(data.properties);
                filters.demographicId = data.defaultDemographicId;
                filters.surveyId = data.defaultSurveyId;
                filters.versionId = data.defaultVersionId;
                filters.stationId = '0';
                filters.loaded = true;
                setPerformanceData(data.items);
                setDayPartTable(data.dayPartTable);
                setDeliveryTable(data.delivery);
                setLoadingData(false);
            })
            .catch();
    };
    // ASSP-7730 Define resetData() method to be called by the PCA Reset button - contents of
    // the campaign.id useEffect moved into resetData() and resetData() used in the useEffect
    const resetData = () => {
        if (!campaign?.id) return;
        filters.dateRange = [campaign.startDate, campaign.endDate];
        filters.demographicId = 0;
        filters.surveyId = 0;
        filters.dayPartId = -1;
        filters.scriptFactorId = 0;
        filters.versionId = 0;
        filters.stationId = '0';
        filters.spotTypeIds = [];
        filters.stationIds = [];
        filters.dayPartIds = [];
        filters.campaignBurstIds = [];
        filters.propertySelectionIds = [];
        filters.scriptFactorIds = [];
        filters.spotTypeIds = [];

        setFinancialStats(initFinancialStats);
        setPerformanceData([]);
        setDayPartTable([]);
        setDeliveryTable([]);
        setLoadingData(true);
        loadData();
    }
    useEffect(() => {
        resetData();
    }, [campaign?.id]);
    useEffect(() => {
        // only graph data
        setLoadingData(true);
        loadDataPartial();
    }, [filters]);
    return (
        <PerformanceContext.Provider
            value={{
                dayParts,
                setDayparts,
                stations,
                setStations,
                scriptFactors,
                setScriptFactors,
                surveys,
                setSurveys,
                demographics,
                setDemographics,
                properties,
                setProperties,
                spotTypes,
                setSpotTypes,
                versions,
                setVersions,
                airtimeBursts,
                setAirtimeBursts,
                performanceData,
                setPerformanceData,
                dayPartTable,
                setDayPartTable,
                deliveryTable,
                setDeliveryTable,
                setCampaign,
                filters,
                setFilters,
                financialStats,
                setFinancialStats,
                loadingData,
                resetData
            }}
        >
            {children}
        </PerformanceContext.Provider>
    );
};
export { PerformanceContext, PerformanceProvider };
